import React, { useState, useEffect, useRef } from 'react';
import './AuditList.css';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import Support from '../contact-popup-module/Support';
import {
    Dialog,
    DialogContent,
} from "@mui/material";
import ShareAuditOptions from '../audit-creation-module/inspection-mode/ShareAuditOptions';
const AuditList = () => {
    const [activeTab, setActiveTab] = useState('active');
    const [currentFilter, setCurrentFilter] = useState('all');
    const share = `${process.env.PUBLIC_URL}/custom-icons/share.svg`;
    const calendar = `${process.env.PUBLIC_URL}/custom-icons/calendar.png`;
    const menuIcon = `${process.env.PUBLIC_URL}/custom-icons/menu-icon.png`;
    const infoIcon = `${process.env.PUBLIC_URL}/custom-icons/info-icon.png`;
    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const popupRef = useRef(null);
    const navigate = useNavigate()
    const location = useLocation();
    const [audits, setAudits] = useState([]);
    const [agentDetails, setAgentDetails] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [open, setOpen] = useState(false);
    const [openSharePopup, setOpenSharePopup] = useState(false);
    const [selectedAuditUrl, setSelectedAuditUrl] = useState('');


    // Fetch audits from backend
    useEffect(() => {
        const fetchAudits = async () => {
            try {
                const userID = location.state.userId;
                if (!userID) {
                    console.error("userID is missing");
                    return;
                }

                // Make the API call to fetch audit data
                const response = await axios.post('/agentApis/getAgentAllAuditInfo', { userID });
                const auditData = response.data.map(item => ({
                    id: item.audit,  // Map audit ID
                    date: item.lead_creation_time.split(' ')[0],  // Use 'lead_creation_time' as date
                    time: item.lead_creation_time.split(' ')[1],  // Use 'lead_creation_time' as time
                    status: item.used === ('processing' || 'created') ? 'active' : 'inactive',  // Map 'used' status
                    type: ['Inspection'],  // You can adjust this based on your data
                    mode: item.audit_mode,  // You can add modes here dynamically
                    name: 'Abc xyz',  // You can map other fields if available
                    address: 'Address',  // Static or dynamic based on backend data
                }));
                setAudits(auditData);
                console.log(response.data);

            } catch (error) {
                console.error("Error fetching audit data:", error);
            }
        };

        fetchAudits(); // Call the function to fetch audits on component mount
    }, []);

    const userID = location.state.userId;
    useEffect(() => {
        const fetchAgentDetails = async () => {
            try {
                // Make a POST request to the backend with userID
                const response = await axios.post("/agentApis/getCompleteAgentInfo", { userID });

                // Check if data was returned successfully
                if (response.status === 200) {
                    console.log("261", response);
                    setAgentDetails(response.data[0]);
                    console.log("263", response.data[0]);
                } else {
                    setError("Failed to fetch agent details");
                }
            } catch (err) {
                setError("An error occurred while fetching data");
                console.error("Error fetching data:", err);
            } finally {
                setLoading(false);
            }
        };

        if (userID) {
            fetchAgentDetails();
        }
    }, [userID]);

    // Tab switching handler
    const handleTabClick = (tab) => {
        setActiveTab(tab);
    };

    // Filter button handler
    const handleFilterClick = (filter) => {
        setCurrentFilter(filter);
    };

    // Function to filter audits
    const filteredAudits = audits.filter(audit => {
        return (
            audit.status === activeTab &&
            (currentFilter === 'all' || audit.type.includes(currentFilter))
        );
    });

    const handleClickOutside = (event) => {
        if (popupRef.current && !popupRef.current.contains(event.target)) {
            setIsPopupVisible(false);
        }
    };

    useEffect(() => {
        if (isPopupVisible) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isPopupVisible]);

    const handleNavigateClick = (audit) => {
        const userId = location.state.userId
        console.log(userId);
        navigate(`/auditDescription`, { state: { audit, userID, agentDetails } });
    };
    const handleAddClick = () => {
        navigate('/home')
    }

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };
    const handleLogout = () => {
        navigate('/login')
    }
    const link_to_audit = (audit,) => {
        console.log(audit?.mode, 187);
        const hostname = window.location.hostname;
        const port = window.location.port;
        const baseURL = `https://${hostname}:${port}`;
        let url;
        const auditId = audit.id;
        if (audit?.mode === "video") {
            url = `/audit/video/permission/${auditId}`;
        } else if (audit?.mode === "photo") {
            url = `/audit/photo/permission/${auditId}`;
        } else {
            url = `/audit/hybrid/permission/${auditId}`;
        }
        // return url;
        return `https://${hostname}:${port}${url}`
    };
    const handleShareClick = (audit) => {
        console.log("share clicked");
        
        const auditUrl = link_to_audit(audit); // Generate the audit URL
        setSelectedAuditUrl(auditUrl); // Set the URL for sharing
        setOpenSharePopup(true); // Open the share popup
    };

    const handleShareClose = () => {
        setOpenSharePopup(false); // Close the share popup
    };
    return (
        <div className="audit-list-container">
            <div className="header-container">
                <h1>Assigned audits</h1>
                <img src={menuIcon} alt="Options" className="three-dots-icon" onClick={() => setIsPopupVisible(!isPopupVisible)} />
                {isPopupVisible && (
                    <div className="popup-menu" ref={popupRef}>
                        <button className='popup-item' onClick={handleClickOpen}>
                            {/* <img src={infoIcon} alt="Info" className="info-icon" /> */}
                            Help</button>
                        <button className='popup-item' onClick={handleLogout} >Logout</button>
                    </div>
                )}
            </div>
            {/* Support Popup */}
            <Dialog open={open} onClose={handleClose} className="support-popup-dialog">
                <DialogContent className="support-popup-content">
                    <Support />
                    <button onClick={handleClose} className="close-btn">close</button>
                </DialogContent>
            </Dialog>
            <div className="tabs">
                <button className={activeTab === 'active' ? 'active' : ''} onClick={() => handleTabClick('active')}>ACTIVE</button>
                <button className={activeTab === 'inactive' ? 'active' : ''} onClick={() => handleTabClick('inactive')}>INACTIVE</button>
            </div>

            <div className="filters">
                <button className="filter-button all" onClick={() => handleFilterClick('all')}>All</button>
                <button className="filter-button" onClick={() => handleFilterClick('Inspection')}>Inspection</button>
                <button className="filter-button" >Claim</button>
                {/* <button className="filter-button" onClick={() => handleFilterClick('Claim')}>Claim</button> */}
            </div>

            <div className="audit-cards">
                {filteredAudits.map(audit => (
                    <div className="audit-card" key={audit.id}>
                        <div className="audit-header">
                            <div className="header-one">
                                <p className="audit-id">{audit.id}</p>
                                <div className="date-container">
                                    <img src={calendar} alt="Calendar Icon" className="calendar-icon" />
                                    <p>{audit.date}</p>
                                </div>
                            </div>
                            <div className="header-two">
                                <div className="audit-tags">
                                    {audit.type.map((tag, index) => (
                                        <span key={index} className="audit-tag">{tag}</span>
                                    ))}
                                    <span className="audit-tag">{audit.mode}</span>
                                </div>
                                <p>{audit.time}</p>
                            </div>
                        </div>

                        <div className="audit-details">
                            <p>{agentDetails && agentDetails.FirstName}</p>
                            <p>{agentDetails && agentDetails.address}</p>
                        </div>

                        <div className="audit-actions">
                            <button className="share-button" onClick={() => handleShareClick(audit)} >
                                <img src={share} alt="Share Icon" className="share-icon" />
                                Share
                            </button>
                            <button className="navigate-button" onClick={() => handleNavigateClick(audit)}>{'>'}</button>
                        </div>
                    </div>
                ))}
            </div>

            <button className="fab" onClick={() => handleAddClick()}>+</button>
            {/* Share Audit Popup */}
            <Dialog open={openSharePopup} onClose={handleShareClose} className="share-popup-dialog">
                <DialogContent className="share-popup-content">
                    <ShareAuditOptions auditUrl={selectedAuditUrl} />
                    <button onClick={handleShareClose} className="close-btn">Close</button>
                </DialogContent>
            </Dialog>
        </div>
    );
};

export default AuditList;
